<template>
    <div
        class="relative rounded-1.25 overflow-hidden"
        :class="[width, customStyle, height]"
    >
        <div :class="skeletonClass"></div>
    </div>
</template>

<script setup>
defineProps({
    width: {
        type: String,
        default: '',
    },
    height: {
        type: String,
        default: '',
    },
    customStyle: {
        type: String,
        default: 'bg-gray-80 dark:bg-blue-770',
    },
    skeletonClass: {
        type: String,
        default: 'skeleton-loader',
    },
})
</script>
